import pixAxios from '@/axios/pixAxios.js';
import jllLocalstorageManager from 'jll-localstorage-manager';
import Console from '@/shared/console';

const pricingToolModule = {
  namespaced: true,
  state: {
    CountryData: [],
    RecordId: null,
  },
  actions: {
    async getCountryData({ commit }) {
      const localStorageKey = 'PricingToolCountryData';
      const storedData = jllLocalstorageManager.get(localStorageKey);
      const twentyFourHours = 1000 * 60 * 60 * 24;
      if (storedData != null) {
        commit('setCountryData', storedData);
      } else {
        try {
          const response = await pixAxios.get('api/PricingTool/GetCountryData');
          const countryData = response.data;
          jllLocalstorageManager.set(localStorageKey, countryData, twentyFourHours);
          commit('setCountryData', countryData);
        } catch (error) {
          Console.log(error);
        }
      }
    },

    async save({ commit, state }, payload) {
      if (payload.costTotal) {
        const response = await pixAxios.post('api/PricingTool/Save', { ...payload, RecordId: state.RecordId });
        const recordId = response?.data?.Id;
        commit('Save', recordId);
      }
    },
  },
  mutations: {
    setCountryData(state, countryData) {
      state.CountryData = countryData;
    },

    save(state, recordId) {
      state.RecordId = recordId;
    },
  },
  getters: {
    getCountryData(state) {
      try {
        return state.CountryData;
      } catch (err) {
        return [];
      }
    },
  },
};
export default pricingToolModule;
